import React from 'react'
import { FormattedMessage, MessageDescriptor } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import {
  CALENDAR_LANDING_INFO,
  CALENDAR_LANDING_TITLES,
} from '@lyrahealth-inc/shared-app-logic/src/features/calendar/provider/messages'
import { LANDING_PAGE_INFO } from '@lyrahealth-inc/shared-app-logic/src/features/calendar/provider/types'

import confirmed from '../../assets/confirmed.png'
import referrals from '../../assets/referrals.png'
import schedule from '../../assets/schedule.png'
import { BodyText } from '../../atoms/bodyText/BodyText'
import { Image } from '../../atoms/image/Image'
import { Title } from '../../atoms/title/Title'
import { BodyTextSize, TitleSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'

const DescriptionContainer = styled.View(() => ({
  maxWidth: '254px',
}))

const InformationContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  display: 'flex',
  width: '100%',
  maxWidth: '944px',
  paddingTop: theme.spacing['32px'],
  paddingBottom: theme.spacing['48px'],
  flexDirection: 'row',
  justifyContent: 'space-between',
}))

const LandingItem = styled.View(() => ({
  maxWidth: '254px',
}))

const TitleContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  marginBottom: theme.spacing['8px'],
  marginTop: theme.spacing['16px'],
}))

const HYBRID_BOOKING_LANDING_ITEMS = [
  {
    imageSource: referrals,
    title: CALENDAR_LANDING_TITLES[LANDING_PAGE_INFO.REFERRALS],
    description: CALENDAR_LANDING_INFO[LANDING_PAGE_INFO.REFERRALS],
  },
  {
    imageSource: confirmed,
    title: CALENDAR_LANDING_TITLES[LANDING_PAGE_INFO.FASTER_BOOKING],
    description: CALENDAR_LANDING_INFO[LANDING_PAGE_INFO.FASTER_BOOKING],
  },
  {
    imageSource: schedule,
    title: CALENDAR_LANDING_TITLES[LANDING_PAGE_INFO.EASIER_MANAGEMENT],
    description: CALENDAR_LANDING_INFO[LANDING_PAGE_INFO.EASIER_MANAGEMENT],
  },
]

export const ProviderCalendarLandingContent: React.FC = () => {
  const { colors } = useTheme() as ThemeType

  const generateSchedulingInfo = (
    landingElement: {
      imageSource: any
      title: MessageDescriptor
      description: MessageDescriptor
    },
    index: number,
  ) => {
    return (
      <LandingItem key={index}>
        <Image source={landingElement.imageSource} style={{ width: 67, height: 67 }} accessibilityIgnoresInvertColors />
        <TitleContainer>
          <Title
            level='4'
            color={colors.textSecondary}
            size={TitleSize.XSMALL}
            text={<FormattedMessage {...landingElement.title} />}
          />
        </TitleContainer>
        <DescriptionContainer>
          <BodyText
            color={colors.textSecondary}
            size={BodyTextSize.SMALL}
            text={<FormattedMessage {...landingElement.description} />}
          />
        </DescriptionContainer>
      </LandingItem>
    )
  }

  const schedulingInfoList = HYBRID_BOOKING_LANDING_ITEMS.map(
    (landingElement: { imageSource: any; title: MessageDescriptor; description: MessageDescriptor }, index: number) =>
      generateSchedulingInfo(landingElement, index),
  )
  return <InformationContainer>{schedulingInfoList}</InformationContainer>
}
